import { DOMAIN } from './Palette.constants';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || {};

export const getField = (state, field) => {
    const value = getStore(state)[field];
    return value === undefined || value === null ? '' : value;
};
